import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('chucho_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401) {
            const ruta = window.location.pathname;
            if (ruta !== '/login' && ruta !== '/registro' && !ruta.startsWith('/recuperar')) {
                localStorage.removeItem('chucho_token');
                localStorage.removeItem('chucho_usuario');
                window.location.href = '/login';
            }
        }
        return Promise.reject(err);
    }
);

export const RUTA_ARCHIVOS = API_URL.replace(/\/api$/, '');
export default api;
